// Oberflächen-Manifest der E-Rechnung. Gemeinsame Datei zweier Pakete – sie führt nur die Teile zusammen:
//   ./manifest/outbound.ts   Ausgang (Liste der ausgestellten XRechnungen) und Einstellungen › E-Rechnung
//   ./manifest/inbox.ts      Eingang (E-Rechnungen von Lieferanten) – das Paket des Eingangs ergänzt hier EINEN Import
//                            und seinen Eintrag in PARTS
// Wird von scripts/gen-registry.ts in Node geladen: Seiten nur per lazy-Import in den Teilen, kein CSS, keine Bausteine.
import { defineWebModule, type WebModuleSpec } from '@web/module'
import { inbox } from './manifest/inbox'
import { outbound } from './manifest/outbound'

export type ManifestPart = Omit<WebModuleSpec, 'id'>

const PARTS: readonly ManifestPart[] = [outbound, inbox]

export default defineWebModule({
  id: 'einvoice',
  routes: PARTS.flatMap((part) => part.routes ?? []),
  nav: PARTS.flatMap((part) => part.nav ?? []),
  widgets: PARTS.flatMap((part) => part.widgets ?? []),
  commands: PARTS.flatMap((part) => part.commands ?? []),
  relatedLinks: PARTS.flatMap((part) => part.relatedLinks ?? []),
  scanHandlers: PARTS.flatMap((part) => part.scanHandlers ?? []),
  searchResults: Object.assign({}, ...PARTS.map((part) => part.searchResults ?? {})),
  entityLinks: Object.assign({}, ...PARTS.map((part) => part.entityLinks ?? {})),
})
